var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import "@frameworks/shared-library/stylesheets/components/GenericTooltipInnerContent.scss";
import MandateType from "../MandateType/MandateType";
import MandateCard from "../Mandate/MandateCard";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { fundTypes } from "./constants";
import moment from "moment";
import { EMutualFundFlow } from "../MutualFund";
import { EHoldingType } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import { getValidatedInstallmentForSIPMandate } from "@domains/utils/MFCalculator";
import { EOrderBookStatus } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
var MoreOptionsTxn = function (props) {
    var selectedMandate = props.selectedMandate, setTOCFlow = props.setTOCFlow, mfData = props.mfData, selected = props.selected, setPhysicalFlg = props.setPhysicalFlg, isModify = props.isModify, purchaseFormData = props.purchaseFormData, setSelectedMandate = props.setSelectedMandate, setSelectedMandateId = props.setSelectedMandateId, availableHoldings = props.availableHoldings;
    var _a = __read(useState(false), 2), stepup = _a[0], setStepup = _a[1];
    var moreOptionCompList = [
        // {
        //   leftSideComp: (
        //     <GenericCheckbox
        //       parentClassName="individual-checkbox-wrapper"
        //       checkboxProps={{
        //         onChange: (e) => {
        //           setStepup(!stepup);
        //         },
        //         id: "1",
        //         checked: stepup,
        //         value: 11,
        //       }}
        //       labelProps={{
        //         htmlFor: "",
        //         children: (
        //           <>
        //             <div className="d-flex align-items-center"></div>
        //           </>
        //         ),
        //       }}
        //       checkboxType="han-blue"
        //     />
        //   ),
        //   rightSideText: (
        //     <div className="mgt-5">
        //       <span className="DMSans_13_400 txt_blackOne1">Annual Step-up</span>{" "}
        //       <span className="DMSansNormal_12_400 txt-whispering-periwinkle">(Optional)</span>
        //     </div>
        //   ),
        //   rightSideComp: <>{stepup && <AnnualStepUp />}</>,
        //   tooltipTitle: "You SIP amount will increase by ₹500 each year",
        // },
        {
            leftSideComp: React.createElement("span", { className: "edel-icon-bars side-bars-style" }),
            rightSideText: "Holding Type",
            rightSideComp: (React.createElement(React.Fragment, null, props.isModify &&
                (props === null || props === void 0 ? void 0 : props.displayStatus) === EOrderBookStatus.ACTIVE ? (React.createElement("label", { className: "DMSanN_15_400" }, selected === EHoldingType.Demat ? "Demat" : "Physical")) : (React.createElement(MandateType, { recommendedType: EHoldingType.Demat, availableList: availableHoldings, selected: selected, setPhysicalFlg: setPhysicalFlg })))),
            tooltipTitle: "Select how to hold your mutual fund units:",
            tooltipCustom: fundTypes,
            hidden: availableHoldings.length <= 1,
        },
        {
            leftSideComp: (React.createElement("span", { className: "edel-icon-medal-bookmark txt_lavender-blue font-28" })),
            rightSideText: "Mandate",
            tooltipTitle: "Mandate is a daily transaction limit up to which entity can transact with your bank account. You will be creating this mandate in favour of Indian Clearing Corp. Once created the mandate can be used for active systematic transfers (or SIP) Orders.",
            rightSideComp: (React.createElement(React.Fragment, null, selectedMandate ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "d-flex flex-column ".concat(selectedMandate.hasError ? "has-error" : "", " more-txn-mandate-card-wrapper") },
                    React.createElement(MandateCard, { accountNumber: selectedMandate.shortName + "-" + selectedMandate.mandateId, bankName: selectedMandate.bankName +
                            " *" +
                            selectedMandate.accountNumber.slice(-4), amount: selectedMandate.amount, validTill: moment(selectedMandate.expiryDate).format("Do MMM YYYY"), status: selectedMandate.dpStatus, mandateType: selectedMandate.dpMandateType, hasError: selectedMandate.hasError }),
                    selectedMandate.hasError && (React.createElement("div", { className: "mandate-error-msg w-100" }, selectedMandate.hasError && (React.createElement("span", { className: "text-danger DMSansNormal_12_400 d-flex" },
                        React.createElement("span", null, selectedMandate.errorMessage)))))),
                React.createElement("div", { className: "d-flex justify-content-end mgt-2" },
                    React.createElement(EdButton, { btnTyp: "text-only", className: "txt-han-blue switch-Mandate-button DMSans_13_400", value: React.createElement("div", { className: "d-flex gap-2 align-items-center" },
                            React.createElement("i", { className: "edel-icon-switch-fund font-16" }),
                            React.createElement("span", null, "Switch Mandate")), onClick: function () {
                            setTOCFlow(EMutualFundFlow.MANDATE);
                        } })))) : (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMsanR_10_400 no_mandate_text" }, "No Mandates Available"),
                React.createElement(EdButton, { btnTyp: "tomato-rounded", value: "+  Add New Mandate", onClick: function () {
                        // setledgerPopup(true);
                        setTOCFlow(EMutualFundFlow.NEWMANDATE);
                    } }))))),
        },
    ];
    var updateSelectedMandateWithErrorsIfAny = function () {
        var _a;
        if (!selectedMandate)
            return;
        var errorObj = { hasError: false, errorMessage: "" };
        var validatedInstallmentsForSIP = getValidatedInstallmentForSIPMandate(selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.expiryDate, purchaseFormData.sipDate, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency);
        if (mfData === null || mfData === void 0 ? void 0 : mfData.sipData) {
            var minimumInstallmentNumber = +((_a = mfData === null || mfData === void 0 ? void 0 : mfData.sipData[purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency]) === null || _a === void 0 ? void 0 : _a.minInstNum);
            var installmentNumberError = validatedInstallmentsForSIP < minimumInstallmentNumber;
            var installmentAmountError = +purchaseFormData.amount > +selectedMandate.amount;
            if (installmentAmountError) {
                errorObj = {
                    hasError: true,
                    errorMessage: "The SIP amount exceeds the mandate limit.",
                };
            }
            else {
                errorObj = {
                    hasError: false,
                    errorMessage: "",
                };
            }
            props === null || props === void 0 ? void 0 : props.setFormErrors(function (prev) {
                return __assign(__assign({}, prev), { mandateId: {
                        msg: errorObj.errorMessage,
                        status: errorObj.hasError,
                    } });
            });
            if (installmentNumberError) {
                setSelectedMandate(undefined);
                setSelectedMandateId("");
                return;
            }
            setSelectedMandate(function (prev) {
                return __assign(__assign({}, prev), errorObj);
            });
        }
    };
    useEffect(function () {
        updateSelectedMandateWithErrorsIfAny();
    }, [purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount, selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId]);
    return (React.createElement("div", { className: "primary-more-option-container d-flex flex-column align-items-start gap-4 pdl-20 pt-15" }, moreOptionCompList.map(function (item, index) {
        return (!(item === null || item === void 0 ? void 0 : item.hidden) && (React.createElement("div", { className: "child-container align-items-start", key: "".concat(item.rightSideText, "-").concat(index) },
            React.createElement("div", { className: "left-side-item d-flex align-items-center justify-content-center" }, item.leftSideComp),
            React.createElement("div", { className: "flex-grow-2" },
                React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement(GenericTooltip, { placement: "bottom-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: item.tooltipTitle, tooltipCustom: item.tooltipCustom }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info more-info-tooltip", noButton: true, button: React.createElement("span", { className: "DMSanN_13_400 marginR-7 d-flex align-items-center mgt-5" },
                            item.rightSideText,
                            React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block" })) })),
                React.createElement("div", { className: "marginR-7 marginT-8" }, item.rightSideComp)))));
    })));
};
export default MoreOptionsTxn;
